<div class="flex p-0 w-full overflow-x-hidden">
    <p-toast />
    <app-sidenav class="menu-wrapper flex-shrink-0"></app-sidenav>
    <div class="content-column flex flex-column flex-grow-1 h-screen p-0 relative overflow-x-hidden">
        <app-nav class="nav-wrapper flex-none"></app-nav>
        <!-- Data loading / page switch: the page stays visible underneath -->
        <div class="top-progress">
          <p-progressBar *ngIf="(loading || navigating) && !blocking" mode="indeterminate"
                         [style]="{ height: '3px' }" [attr.aria-label]="'common.loading' | translate" />
        </div>
<!--
        <app-bread [breadItems]="breadItems"></app-bread>
-->

      <div class="flex flex-grow-1 p-2 bg-gray-50 overflow-x-hidden overflow-y-auto" style="min-height: 0;">
        <div class="surface-card shadow-1 border-round w-full h-full overflow-y-auto overflow-x-hidden">
          <router-outlet></router-outlet>
        </div>

      </div>
      <!-- Saving: cover the page so the same action can't be submitted twice -->
      <div class="flex absolute w-full h-full fixed z-5 bg-black-alpha-30" *ngIf="blocking">
        <p-progressSpinner [ariaLabel]="'common.loading' | translate" [classList]="'m-auto'" />
      </div>
    </div>

</div>


